import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  FaCheckCircle as CheckIcon,
  FaMinusCircle as MinusIcon,
  FaTimesCircle as TimesIcon,
} from 'react-icons/fa';

const RunStatusCellRenderer = ({ value }) => {
  const runStatusClassNames = classnames('connection-run-status-icon', {
    'text-danger': value === 0,
    'text-warning': value === 1,
    'text-success': value === 2,
  });

  switch (value) {
    case 0: return <TimesIcon size={15} className={runStatusClassNames} />;
    case 1: return <MinusIcon size={15} className={runStatusClassNames} />;
    case 2: return <CheckIcon size={15} className={runStatusClassNames} />;
    default: return null;
  }
};
RunStatusCellRenderer.propTypes = {
  value: PropTypes.number,
};

export default RunStatusCellRenderer;
